import { render, staticRenderFns } from "./Rotorblade.vue?vue&type=template&id=0798f0ff&scoped=true&"
import script from "./Rotorblade.vue?vue&type=script&lang=ts&"
export * from "./Rotorblade.vue?vue&type=script&lang=ts&"
import style0 from "./Rotorblade.vue?vue&type=style&index=0&id=0798f0ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0798f0ff",
  null
  
)

export default component.exports